import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTemplateState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 486.372,
	height: 363.071,
	viewBox: "0 0 486.372 363.071",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_13377",
			"data-name": "Rectangle 13377",
			width: 486.372,
			height: 363.071,
			fill: "none"
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Group_7579",
		"data-name": "Group 7579",
		transform: "translate(0 -0.004)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_7578",
			"data-name": "Group 7578",
			transform: "translate(0 0.004)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12874",
					"data-name": "Path 12874",
					d: "M458.591,360.256c16.917-27.739,25.374-74.8,27.387-109.087,2.975-50.684-11.12-52.294-34.662-78.6-10.268-11.474,18.564-47.775-25.2-77.762-27.155-18.6-63.77,18.807-86.3-27.591C311.891,9.71,215.706-4,163.289.929,83.2,8.458,29.6,54.568,16.038,85.13c-49.3,111.114,33.617,118.085,3.546,172.213-24.092,43.366-2.17,88.058,9.964,102.913Z",
					transform: "translate(0 -0.004)",
					fill: "#f5faff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12875",
					"data-name": "Path 12875",
					d: "M1290.3,162.977v-.608c1.568,0,3.15-.074,4.7-.217l.056.605c-1.569.144-3.169.218-4.755.219m-4.755-.214c-1.578-.143-3.164-.362-4.716-.649l.111-.6c1.533.284,3.1.5,4.66.641Zm14.226-.66-.111-.6c1.537-.286,3.077-.648,4.58-1.076l.167.585c-1.521.432-3.08.8-4.635,1.088m-23.578-1.072c-1.521-.431-3.04-.938-4.516-1.509l.219-.567c1.458.564,2.96,1.066,4.462,1.491Zm32.727-1.531-.219-.567c1.456-.565,2.9-1.206,4.3-1.9l.271.544c-1.415.707-2.879,1.355-4.353,1.927m-41.6-1.9c-1.415-.7-2.815-1.484-4.16-2.318l.321-.517c1.329.824,2.712,1.594,4.111,2.291Zm50.109-2.348-.321-.517c1.326-.823,2.631-1.719,3.878-2.663l.367.485c-1.262.955-2.583,1.862-3.925,2.7m-58.2-2.661c-1.262-.953-2.494-1.975-3.664-3.041l.409-.449c1.156,1.053,2.374,2.064,3.621,3.006Zm65.783-3.079-.41-.449c1.155-1.053,2.274-2.173,3.327-3.328l.449.409c-1.065,1.169-2.2,2.3-3.366,3.368m-72.818-3.326c-1.067-1.168-2.092-2.4-3.047-3.659l.484-.367c.943,1.245,1.957,2.462,3.011,3.616Zm-5.744-7.582c-.835-1.344-1.617-2.742-2.324-4.155l.544-.272c.7,1.4,1.471,2.778,2.3,4.106ZM1242.2,130.1c-.573-1.474-1.083-2.993-1.517-4.513l.584-.167c.428,1.5.933,3,1.5,4.46Z",
					transform: "translate(-936.479 -94.666)",
					fill: "#9bc1f9"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12876",
					"data-name": "Path 12876",
					d: "M1241.52,458.89c-1.414-2.274-2.737-4.64-3.933-7.032l.92-.46c1.182,2.364,2.49,4.7,3.887,6.949Zm-7.2-14.4c-.97-2.5-1.834-5.065-2.568-7.638l.989-.282c.725,2.542,1.578,5.082,2.537,7.547Zm-4.414-15.48c-.491-2.626-.865-5.311-1.112-7.979l1.024-.1c.244,2.638.614,5.291,1.1,7.885Zm-.459-16.028h-1.029v-.1c0-2.649.121-5.322.357-7.947l1.025.092c-.234,2.594-.353,5.236-.353,7.854Zm1.434-15.842-1.012-.187c.486-2.633,1.1-5.273,1.828-7.847l.99.28c-.719,2.543-1.327,5.152-1.807,7.754m4.326-15.307-.96-.37c.964-2.5,2.057-4.978,3.249-7.376l.921.458c-1.178,2.369-2.258,4.821-3.211,7.288m7.083-14.247-.875-.541c1.407-2.275,2.938-4.513,4.551-6.651l.822.619c-1.594,2.113-3.107,4.325-4.5,6.573m9.58-12.7-.761-.692c1.8-1.98,3.715-3.9,5.69-5.706l.694.759c-1.952,1.785-3.843,3.682-5.623,5.639m11.74-10.739-.622-.819c2.133-1.618,4.366-3.155,6.637-4.569l.544.873c-2.244,1.4-4.451,2.917-6.559,4.515m13.506-8.406-.461-.919c2.394-1.2,4.871-2.3,7.363-3.27l.374.959c-2.462.959-4.911,2.046-7.276,3.23m14.821-5.772-.283-.989c2.572-.735,5.211-1.358,7.842-1.851l.19,1.011c-2.6.487-5.207,1.1-7.749,1.829m15.633-2.932-.1-1.024c2.656-.248,5.364-.375,8.047-.38l0,1.029c-2.652,0-5.328.131-7.953.376",
					transform: "translate(-927.222 -245.79)",
					fill: "#9bc1f9"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12877",
					"data-name": "Path 12877",
					d: "M579.651,215.322l.081-.813c2.091.207,4.216.32,6.317.335l-.006.817c-2.126-.015-4.276-.129-6.392-.339m25.379-2.164-.218-.788c2.026-.56,4.049-1.222,6.013-1.966l.29.764c-1.987.754-4.034,1.423-6.085,1.99m11.958-4.536-.359-.734c1.885-.924,3.75-1.948,5.544-3.044l.426.7c-1.815,1.11-3.7,2.146-5.61,3.081m10.911-6.667-.489-.655c1.678-1.252,3.324-2.6,4.891-4.01l.118-.106.547.607-.118.107c-1.586,1.426-3.251,2.791-4.949,4.058m9.017-9.219c1.426-1.546,2.8-3.175,4.069-4.841l.649.5c-1.289,1.686-2.674,3.334-4.118,4.9Zm7.673-10.039c1.115-1.78,2.16-3.634,3.105-5.51l.73.368c-.956,1.9-2.014,3.775-3.142,5.576Zm9.192-23.425c.395-2.063.7-4.169.9-6.261l.813.079c-.206,2.117-.513,4.248-.913,6.336Zm1.226-12.579c.011-2.1-.076-4.229-.257-6.321l.814-.071c.184,2.117.271,4.27.26,6.4ZM653.912,134.1c-.374-2.069-.849-4.144-1.412-6.167l.787-.219c.57,2.047,1.05,4.147,1.429,6.241Zm-3.389-12.176c-.749-1.963-1.6-3.914-2.526-5.8l.733-.361c.939,1.907,1.8,3.881,2.556,5.868Zm-5.58-11.337c-1.1-1.787-2.292-3.548-3.554-5.232l.654-.49c1.276,1.7,2.486,3.485,3.6,5.294Z",
					transform: "translate(-437.525 -79.153)",
					fill: "#9bc1f9"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12878",
					"data-name": "Path 12878",
					d: "M199.381,696.509a7.685,7.685,0,0,0,.806,1.956c2.323,4.229,7.714,10.263,7.714,10.263l4.17-9.395s-.68-2.95-1.859-7.167c-4.027,1.051-7.863,1.66-10.831,4.343",
					transform: "translate(-150.494 -522.454)",
					fill: "#f8a492"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12879",
					"data-name": "Path 12879",
					d: "M193.307,575.527s-23.257,10.015-24.009,9.824c-.484-.123-9.54-15.28-9.637-29.534-.044-6.583,6.792-14.5,14.42-12.936,3.84.789,3.781,1.857,9.463,10.113s9.763,22.534,9.763,22.534",
					transform: "translate(-120.514 -409.621)",
					fill: "#b7c1fc"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12880",
					"data-name": "Path 12880",
					d: "M373.061,1408.977s-.552,9.134-.555,9.153a50.053,50.053,0,0,0-1,5.079c0,3.96,18.806-3.362,14.592-5.117-.382-.159-2.38-1.36-2.506-2.708-.193-2.077-.684-6.278-.684-6.278Z",
					transform: "translate(-280.415 -1063.509)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12881",
					"data-name": "Path 12881",
					d: "M384,1445.5s-4.415,1.211-6.677,1.514-5.243-2.247-6.842-1.558c-1.76.758-1.692,7.583-1.692,7.583s23.678,1.943,30.336-.067c2.638-.8-6.1-4.65-15.125-7.472",
					transform: "translate(-278.365 -1090.951)",
					fill: "#182975"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12882",
					"data-name": "Path 12882",
					d: "M216.16,1408.977s-.552,9.134-.555,9.153a50.053,50.053,0,0,0-1,5.079c0,3.96,18.806-3.362,14.592-5.117-.382-.159-2.973-2.257-3.1-3.605-.193-2.077-.091-5.381-.091-5.381Z",
					transform: "translate(-161.984 -1063.509)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12883",
					"data-name": "Path 12883",
					d: "M226.67,1445.5s-4.415,1.211-6.677,1.514-5.243-2.247-6.842-1.558c-1.76.758-1.831,7.583-1.831,7.583s23.785,2.265,30.475-.067c2.6-.905-6.1-4.65-15.125-7.472",
					transform: "translate(-159.506 -1090.951)",
					fill: "#182975"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12884",
					"data-name": "Path 12884",
					d: "M244.393,509.751l16.563-23.2c.07-.2.22-.619.45-1.254.834-2.3,2.57-7.093,4.082-11.859l.016-.051c.475-1.666,1.482-4.572,2.456-7.384,1.083-3.126,2.426-7,2.473-7.664-.042-.113-.12-.316-.224-.586a53.456,53.456,0,0,1-1.719-6.963c-.185-1.04-.37-3.566.866-3.566,1.943,0,1.017,2.523,1.913,4.1a39.84,39.84,0,0,0,1.346-5.258l.325-4.933c.063-.372-.333-3.093,1.029-3.093l.065,0c1.224.09,1.2,2.983,1.706,7.876.161-.563.322-1.242.443-1.866a17.915,17.915,0,0,1,.414-2.582c-.246-1.363-.1-3.514,1.349-3.311.728.1.668,3.1.668,3.1-.008.412-.051,3.585-.028,4.212.15-1.065.731-5.606,1.871-5.606.945,0,1.021,1.222,1,2.189-.012.573-.605,5.493-.638,6.065.445-.746.972-5.082,1.413-5.082,1.843,0,1.176,6.165.5,7.771a7.148,7.148,0,0,0-.21.86,15.134,15.134,0,0,1-1.58,4.587c-1.157,1.979-2.752,5.125-3,5.607-.178.983-.732,4.517-1.43,8.963-.3,1.9-.625,3.988-.966,6.149l-.018,0c-.062.468-.408,1.954-1.718,7.532-1.793,7.633-1.979,7.963-2.058,8.1-.778,1.378-18.637,25.63-19.4,26.662l-.448.609Z",
					transform: "translate(-184.47 -330.635)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12885",
					"data-name": "Path 12885",
					d: "M358.533,498.813s-1.344-3.438-3.738-3.444a2.753,2.753,0,0,1,2.484.425c1.146.908,1.254,3.019,1.254,3.019",
					transform: "translate(-267.802 -373.813)",
					fill: "#f47458"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12886",
					"data-name": "Path 12886",
					d: "M221.507,480.287l-2.132,13.485s8.124,6.524,12.861,5.148c3.974-1.155,1.249-6.35,1.249-6.35s-2.117-7.2-1.467-10.972-10.51-1.311-10.51-1.311",
					transform: "translate(-165.586 -361.93)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12887",
					"data-name": "Path 12887",
					d: "M228.341,484.368a33.188,33.188,0,0,0,9.2,2.591,17.9,17.9,0,0,1-.217-5.358c.3-1.741-1.916-2.153-4.389-2.093-3.236.278-6.121.783-6.121.783l-.41,2.591a6.692,6.692,0,0,0,1.941,1.485",
					transform: "translate(-170.889 -361.934)",
					fill: "#fe875e"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12888",
					"data-name": "Path 12888",
					d: "M186.188,396.97c-.335,0,3.212,15.065,8.7,17.656s13.675,1.241,15.211-2.816c1.7-4.487-4.5-19.856-12.218-21.808s-11.693,6.968-11.693,6.968",
					transform: "translate(-140.52 -294.167)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12889",
					"data-name": "Path 12889",
					d: "M171.932,360.641a17.286,17.286,0,0,0-7.074,7.815c-2.058.976-4.548,3.089-5.743,8.78-1.47,7,3.755,12.391,9.294,14.014s6.4,5.288,6.4,5.288l.628-3.945a15.609,15.609,0,0,0-3.085-5.154c-1.853-1.719.878-4.224,1.118-6.268.185-1.573-.974-4.628-.723-7.21,0,0,3.078-4.665,6.112-5.817,5.173-1.965-1.3-10.748-6.923-7.5",
					transform: "translate(-119.912 -271.678)",
					fill: "#13375b"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12890",
					"data-name": "Path 12890",
					d: "M208.437,449.5c.717,1.74.424,3.467-.655,3.858s-2.536-.7-3.253-2.442-.424-3.467.655-3.858,2.536.7,3.253,2.442",
					transform: "translate(-154.084 -337.386)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12891",
					"data-name": "Path 12891",
					d: "M305.064,687.835l31.949-5.209s-3.635-9.151-4.934-9.151-24.158,9.979-24.158,9.979L306.1,687.1Z",
					transform: "translate(-230.265 -508.346)",
					fill: "#f8a492"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12892",
					"data-name": "Path 12892",
					d: "M221.562,816.887s-3.187,15.408-1.888,27.091,1.4,53.185,1.4,53.185l-4.956,66.4,11.76.256s13.945-66.371,13.685-64.667,4.676-46.732,4.676-46.732l-16.625-37Z",
					transform: "translate(-163.128 -615.492)",
					fill: "#182975"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12893",
					"data-name": "Path 12893",
					d: "M248.611,802.669s-2.078,13.874.52,19.958,22.28,65.789,22.54,70.656,6.805,58.673,6.805,58.673l13.675-.385,2.958-59.821-6.195-75.185L282.9,797.558Z",
					transform: "translate(-187.059 -602.005)",
					fill: "#182975"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12894",
					"data-name": "Path 12894",
					d: "M219.376,524.28s3.372,2.213,6.517,1.956,7.592-3.159,7.592-3.159l-.618-2.095s-8.136-1.185-8.341-1.057-5.15,4.354-5.15,4.354",
					transform: "translate(-165.587 -392.439)",
					fill: "#f7a491"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12895",
					"data-name": "Path 12895",
					d: "M365.956,636.826s12.085,11.4,17.54,9.457,7.712-8.6-5.6-18.341c-11.912-8.715-11.943,8.883-11.943,8.883",
					transform: "translate(-276.227 -472.148)",
					fill: "#f8a492"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12896",
					"data-name": "Path 12896",
					d: "M228.781,580.255c-1.8-9.767-14.806-40.161-15.845-45.758-.505-2.723-7.523-2.783-14.208-2.427-7.061.375-14.075,1.268-14.075,1.268s-6.251,1.027-9,3.6-3.481,9.7.473,23.233c3.121,10.679,6.99,16.543,8.9,24.322.388,2.609.72,5.184,1.16,8.191.7,11.632-.009,27-.009,27s34.029,7.059,46.757-3.651c0,0-2.317-25.773-4.156-35.779",
					transform: "translate(-130.864 -401.495)",
					fill: "#b7c1fc"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12897",
					"data-name": "Path 12897",
					d: "M317.535,560.455s-13.352,11.022-14.132,11.022c-.5,0-19.054-13.648-23.337-24.86-2.368-6.2,2.6-13.133,8.27-13.11,3.931.016,5.679,1.029,13.472,7.6s15.726,19.347,15.726,19.347",
					transform: "translate(-210.94 -402.696)",
					fill: "#b7c1fc"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12898",
					"data-name": "Path 12898",
					d: "M1119.33,1230.506h0c-1.37.858-3.5-.11-4.714-2.147l-26.064-70.627,4.9-3.067,26.146,70.765c1.187,1.984,1.069,4.241-.265,5.077",
					transform: "translate(-821.648 -871.551)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_13373",
					"data-name": "Rectangle 13373",
					width: 6.211,
					height: 99.563,
					transform: "translate(267.589 185.083)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12899",
					"data-name": "Path 12899",
					d: "M1022.242,892.118h33.177a4.585,4.585,0,0,0,0-9.171h-33.177a4.585,4.585,0,1,0,0,9.171",
					transform: "translate(-768.136 -666.457)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12900",
					"data-name": "Path 12900",
					d: "M913.212,1220.841h0c1.37.858,3.5-.11,4.715-2.147l44.132-73.766-4.9-3.068-44.214,73.9c-1.187,1.984-1.069,4.241.265,5.076",
					transform: "translate(-688.482 -861.887)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12901",
					"data-name": "Path 12901",
					d: "M1141.109,1220.841h0c-1.37.858-3.5-.11-4.715-2.147l-44.132-73.766,4.9-3.068,44.214,73.9c1.187,1.984,1.069,4.241-.265,5.076",
					transform: "translate(-824.449 -861.887)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_13374",
					"data-name": "Rectangle 13374",
					width: 259.558,
					height: 189.368,
					transform: "translate(140.117 29.255)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12902",
					"data-name": "Path 12902",
					d: "M1206.07,336.186H1098.441a3.192,3.192,0,0,1-3.191-3.192V245.587a3.191,3.191,0,0,1,3.191-3.191H1206.07a3.191,3.191,0,0,1,3.192,3.191v87.407a3.192,3.192,0,0,1-3.192,3.192",
					transform: "translate(-826.704 -182.964)",
					fill: "#e9e8fa"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_13375",
					"data-name": "Rectangle 13375",
					width: 264.95,
					height: 5.771,
					transform: "translate(137.422 215.738)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_13376",
					"data-name": "Rectangle 13376",
					width: 264.95,
					height: 5.837,
					transform: "translate(137.422 23.418)",
					fill: "#5c61a3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12903",
					"data-name": "Path 12903",
					d: "M734.768,605.048H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -451.825)",
					fill: "#dbe0fd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12904",
					"data-name": "Path 12904",
					d: "M734.768,558.631H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -416.789)",
					fill: "#e9e8fa"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12905",
					"data-name": "Path 12905",
					d: "M734.768,512.215H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -381.754)",
					fill: "#e9e8fa"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12906",
					"data-name": "Path 12906",
					d: "M734.768,465.8H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9V463.9a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -346.718)",
					fill: "#dbe0fd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12907",
					"data-name": "Path 12907",
					d: "M734.768,419.383H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -311.683)",
					fill: "#dbe0fd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12908",
					"data-name": "Path 12908",
					d: "M734.768,372.967H637.708a1.9,1.9,0,0,1-1.9-1.9v-2.654a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -276.648)",
					fill: "#e9e8fa"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12909",
					"data-name": "Path 12909",
					d: "M734.768,326.551H637.708a1.9,1.9,0,0,1-1.9-1.9V322a1.9,1.9,0,0,1,1.9-1.9h97.061a1.9,1.9,0,0,1,1.9,1.9v2.654a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-479.913 -241.613)",
					fill: "#dbe0fd"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12910",
					"data-name": "Path 12910",
					d: "M735.378,259.431h-97c-1.419,0-2.571-1.883-2.571-4.205s1.151-4.206,2.571-4.206h97c1.42,0,2.571,1.883,2.571,4.206s-1.151,4.205-2.571,4.205",
					transform: "translate(-479.913 -189.473)",
					fill: "#e9e8fa"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12911",
					"data-name": "Path 12911",
					d: "M1478.085,785.5H1460.03a1.9,1.9,0,0,1-1.9-1.9v-4.625a1.9,1.9,0,0,1,1.9-1.9h18.055a1.9,1.9,0,0,1,1.9,1.9V783.6a1.9,1.9,0,0,1-1.9,1.9",
					transform: "translate(-1100.609 -586.542)",
					fill: "#7284fa"
				})
			]
		})
	})]
});
export default SvgEmptyTemplateState;
